import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "@/components/wedding/Layout";
import HomePage from "@/pages/HomePage";
import StoryPage from "@/pages/StoryPage";
import GalleryPage from "@/pages/GalleryPage";
import EventsPage from "@/pages/EventsPage";
import VenuePage from "@/pages/VenuePage";
import GuestbookPage from "@/pages/GuestbookPage";
import AdminPage from "@/pages/AdminPage";

function App() {
  useEffect(() => {
    document.title = "Varsha & Parag · June 2026";
  }, []);

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/admin" element={<AdminPage />} />
        <Route element={<Layout />}>
          <Route path="/" element={<HomePage />} />
          <Route path="/story" element={<StoryPage />} />
          <Route path="/gallery" element={<GalleryPage />} />
          <Route path="/events" element={<EventsPage />} />
          <Route path="/venue" element={<VenuePage />} />
          <Route path="/guestbook" element={<GuestbookPage />} />
          <Route path="*" element={<HomePage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
